import { css } from '@emotion/react';
import * as React from 'react';

import { Spinner } from '~src/commons/components';
import { useTranslations } from '~src/commons/utils/translations/translate';
import { colors } from '~src/theme/colors';
import { Button } from '~src/ui/button';

interface DeleteAddressOverlayProps {
  onDelete: () => void;
  onCancel: () => void;
  isFetching: boolean;
}

export const DeleteAddressOverlay: React.VFC<DeleteAddressOverlayProps> = ({
  onCancel,
  onDelete,
  isFetching,
}) => {
  const { tICU } = useTranslations();

  return (
    <div css={styles.overlay}>
      <div css={styles.wrapper}>
        {isFetching || (
          <span css={styles.text}>
            {tICU('widget.delivery_address.DELETE_ADDRESS_ANYWAY_TEXT')}
          </span>
        )}
        <Button
          css={styles.deleteButton}
          disabled={isFetching}
          buttonType="tertiary"
          onClick={onDelete}
        >
          {isFetching ? (
            <Spinner size="medium" circleColor={colors.neutral91} spinnerColor={colors.error35} />
          ) : (
            tICU('widget.delivery_address.DELETE_ADDRESS_ANYWAY_BTN')
          )}
        </Button>
        <Button disabled={isFetching} buttonType="tertiary" onClick={onCancel}>
          {tICU('widget.CANCEL_BUTTON')}
        </Button>
      </div>
    </div>
  );
};

const styles = {
  overlay: css({
    position: 'absolute',
    display: 'flex',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    backgroundColor: colors.overlayBackgroundColor,
  }),
  wrapper: {
    marginTop: 'auto',
    width: '100%',
    padding: '16px',
    backgroundColor: colors.white,
  },
  text: {
    width: '100%',
    display: 'inline-block',
  },
  deleteButton: {
    color: colors.error35,
  },
};
